import { useState } from "react";
import ActionModal from "./ActionModal";
import type { AcceptButtonDetails } from "./types";
// import TextField from "@/components/common/text-field";

interface Props {
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
  acceptButtonDetails: AcceptButtonDetails;
  onApprove: (daysGranted: string) => Promise<void>;
  data: { requested_amount: number | null; requested_unit: string | null };
}

const ApproveModal = ({
  isLoading,
  isOpen,
  onClose,
  acceptButtonDetails,
  data,
  onApprove,
}: Props) => {
  const [daysGranted, setDaysGranted] = useState<string>("");
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const value = event.target.value;
  //   const numericValue = value.replace(/\D/g, "");
  //   setDaysGranted(numericValue);
  // };
  const handleClose = () => {
    setDaysGranted("");
    onClose();
  };

  const handleAccept = async () => {
    try {
      await onApprove(daysGranted);
      setDaysGranted("");
      onClose();
    } catch {
      // Error handling can be implemented here if needed
    }
  };

  const getFormatedDateText = () => {
    const requested_amount = data?.requested_amount ?? 0;
    const requested_unit = data?.requested_unit ?? "day";

    const units: Record<string, { singular: string; plural: string }> = {
      minute: { singular: "minuto", plural: "minutos" },
      hour: { singular: "hora", plural: "horas" },
      day: { singular: "día", plural: "días" },
      week: { singular: "semana", plural: "semanas" },
      month: { singular: "mes", plural: "meses" },
      year: { singular: "año", plural: "años" },
    };

    const unitData =
      requested_unit && units[requested_unit]
        ? units[requested_unit]
        : units.day;

    const unitText =
      requested_amount === 1 ? unitData.singular : unitData.plural;

    return `${requested_amount} ${unitText}`;
  };

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={handleClose}
      onAccpet={handleAccept}
      title="Aprobación de prórroga"
      description="Detalla cuántos días van a añadirse a este paso."
      acceptButtonDetails={{
        ...acceptButtonDetails,
        disabled: false,
        isLoading,
      }}
    >
      {/* <div>
        <TextField
          required
          label="Días otorgados"
          value={daysGranted}
          onChange={handleChange}
          placeholder="Escribe el número de días otorgados"
          disabled={false}
        />
      </div> */}
      <div className="flex justify-center mb-8">
        <span className="font-normal text-lg text-center text-[#8118EB] bg-[#9D5AFF1A] p-3 rounded-lg w-full">
          La prórroga se otorgorá por:{" "}
          <span className="font-semibold">{getFormatedDateText()}</span>
        </span>
      </div>
    </ActionModal>
  );
};

export default ApproveModal;
